import React, { useState, useEffect } from "react";
import {
  Box,
  Text,
  useColorModeValue,
  Flex,
  Textarea,
  Switch
} from "@chakra-ui/react";

import HighlightedTextBox from "./HighlightedTextBox";
import CustomizeAITextHeaders from "./CustomizeAITextHeaders";
import CustomizeAIPreviewSwitch from "./CustomizeAIPreviewSwitch";


const update = (obj, key, value) => ({ ...obj, [key]: value });

const fromCSV = (s) =>
  s.split(",").map(x => x.trim()).filter(Boolean);
const toCSV = (arr) => (Array.isArray(arr) ? arr.join(", ") : "");


const CustomizeAIDetail = ({ inEditMode = false, organized_instructions, onChange, PreviewMode = false }) => {
  const bgColor = useColorModeValue("gray.100", "gray.700");
  const setField = (key) => (value) => {
    const next = update(organized_instructions, key, value);
    onChange?.(next);
  };

  const [filtersText, setFiltersText] = useState(
    JSON.stringify(organized_instructions?.availabilities_filters ?? [], null, 2)
  );

  useEffect(() => {
    setFiltersText(
      JSON.stringify(organized_instructions?.availabilities_filters ?? [], null, 2)
    );
  }, [organized_instructions?.availabilities_filters]);


  return (
    PreviewMode ?
      // in preview mode:
      <Box p={1} bgColor={""} width="full" ml={1}>
        <Text fontSize="m" fontWeight="bold" mb={2}> AI Settings </Text>
        <Box borderRadius="md" width="full" mt={2}>
          <Flex minH="90px" flexDirection="column" gap={2} alignItems={"Start"}>
            {/*<Flex flexDirection="column" width="100%" align="start" px={1}>*/}
            {/*  <CustomizeAITextHeaders input="Interaction Guideline"*/}
            {/*                          description="Include details such as a name for your AI, general tone, etc."/>*/}
            {/*  <HighlightedTextBox input={organized_instructions?.interaction_guideline}/>*/}
            {/*</Flex>*/}
            {/*<Flex flexDirection="column" width="100%" px={1}>*/}
            {/*  <CustomizeAITextHeaders input="Appointment Handling Guideline"*/}
            {/*                          description="Include what information needs to be collected and how to respond to questions about appointment handling."/>*/}
            {/*  <HighlightedTextBox input={organized_instructions?.appointment_handling_guideline}/>*/}
            {/*</Flex>*/}
            {/*<Flex flexDirection="column" width="100%" px={1}>*/}
            {/*  <CustomizeAITextHeaders input="Insurance Guideline"*/}
            {/*                          description="This covers details such as accepted insurance, the verification process, and more."/>*/}
            {/*  <HighlightedTextBox input={organized_instructions?.insurance_guideline}/>*/}
            {/*</Flex>*/}
            {/*<Flex flexDirection="column" width="100%" px={1}>*/}
            {/*  <CustomizeAITextHeaders input="Call Transfer Guideline"*/}
            {/*                          description="Details not listed on the website summary that the AI should know."/>*/}
            {/*  <HighlightedTextBox input={organized_instructions?.call_transfer_guideline}/>*/}
            {/*</Flex>*/}
            {/*<Flex flexDirection="column" width="100%" px={1}>*/}
            {/*  <CustomizeAITextHeaders input="FAQ"*/}
            {/*                          description="Frequently asked question. Questions and answers that are common to your practice."/>*/}
            {/*  <HighlightedTextBox input={organized_instructions?.faq}/>*/}
            {/*</Flex>*/}
            {/*<Flex flexDirection="column" width="100%" px={1}>*/}
            {/*  <CustomizeAITextHeaders input="Practice Optimizer Information"*/}
            {/*                          description="Expxanation of how the office manages its data, such as the process for adding treatments."/>*/}
            {/*  <HighlightedTextBox input={organized_instructions?.practice_optimizer_information}/>*/}
            {/*</Flex>*/}
            {/*<Flex flexDirection="column" width="100%" px={1}>*/}
            {/*  <Text fontSize="sm" fontWeight="bold"> Appointment Information Collection </Text>*/}
            {/*</Flex>*/}
            <Flex flexDirection="column" width="100%" pl={3}>
              <HighlightedTextBox header="Appointment blocker fields"
                                  description="Will not book appointment without this information"
                                  input={toCSV(organized_instructions?.booking_blocker_fields)}/>
              <HighlightedTextBox header="Appointment required fields"
                                  description="Requested field but AI will book the appointment even if it is not provided."
                                  input={toCSV(organized_instructions?.booking_required_fields)}/>
              <HighlightedTextBox header="Appointment optional fields"
                                  description="Information that can be collect after the appointment is booked."
                                  input={toCSV(organized_instructions?.booking_optional_fields)}/>
              <CustomizeAIPreviewSwitch
                title="Ask if they are a new patient"
                description="Enable if new and existing patients have different data collection requirements."
                value={organized_instructions?.ask_if_new_patient}
                isDisabled={!inEditMode}
              />
              <CustomizeAIPreviewSwitch
                title="New patient only: Appointment blocker fields"
                description="Enable if Appointment blocker fields should only be asked to new patients."
                value={organized_instructions?.booking_blocker_fields_only_for_new_patients}
                isDisabled={!inEditMode}
              />
              <CustomizeAIPreviewSwitch
                title="New patient only: Appointment required fields"
                description="Enable if Appointment required fields should only be asked to new patients."
                value={organized_instructions?.booking_required_fields_only_for_new_patients}
                isDisabled={!inEditMode}
              />
              <CustomizeAIPreviewSwitch
                title=" New patient only: Appointment optional fields"
                description="Enable if Appointment optional fields should only be asked to new patients."
                value={organized_instructions?.booking_optional_fields_only_for_new_patients}
                isDisabled={!inEditMode}
              />
              <CustomizeAIPreviewSwitch
                title=" After hours call transfer"
                description="Enable to allow AI to transfer calls after hours to specific extensions."
                value={organized_instructions?.transfer_to_extension_after_hours}
                isDisabled={!inEditMode}
              />
              <CustomizeAIPreviewSwitch
                title=" Accept medical insurance"
                description="Enable if you accept medical insurance."
                value={organized_instructions?.accept_medical}
                isDisabled={!inEditMode}
              />
            </Flex>
            <Flex flexDirection="column" align="start" width="100%" px={1}>
              <Text fontSize="sm" fontWeight="bold" ml={1}> Filters </Text>
              <HighlightedTextBox
                input={JSON.stringify(organized_instructions?.availabilities_filters ?? [], null, 2)}/>
            </Flex>
          </Flex>
        </Box>
      </Box>
      :
      // edit mode
      <Box p={1} bgColor={bgColor} borderRadius="md" width="full">
        <Flex minH="90px" flexDirection="column" gap={2}>
          {/*<Flex flexDirection="column" width="100%" align="start" px={1}>*/}
          {/*  <CustomizeAITextHeaders input="Interaction Guideline"*/}
          {/*                          description="Include details such as a name for your AI, general tone, etc."/>*/}
          {/*  <Textarea*/}
          {/*    value={organized_instructions?.interaction_guideline || ""}*/}
          {/*    isDisabled={!inEditMode}*/}
          {/*    height="100px"*/}
          {/*    onChange={(e) => setField("interaction_guideline")(e.target.value)}*/}
          {/*  />*/}
          {/*</Flex>*/}
          {/*<Flex flexDirection="column" align="start" width="100%" px={1}>*/}
          {/*  <CustomizeAITextHeaders input="Appointment Handling Guideline"*/}
          {/*                          description="Include what information needs to be collected and how to respond to questions about appointment handling."/>*/}
          {/*  <Textarea*/}
          {/*    value={organized_instructions?.appointment_handling_guideline || ""}*/}
          {/*    onChange={(e) => setField("appointment_handling_guideline")(e.target.value)}*/}
          {/*    isDisabled={!inEditMode}*/}
          {/*    height="100px"*/}
          {/*  />*/}
          {/*</Flex>*/}
          {/*<Flex flexDirection="column" align="start" width="100%" px={1}>*/}
          {/*  <CustomizeAITextHeaders input="Insurance Guideline"*/}
          {/*                          description="This covers details such as accepted insurance, the verification process, and more."/>*/}
          {/*  <Textarea*/}
          {/*    value={organized_instructions?.insurance_guideline || ""}*/}
          {/*    onChange={(e) => setField("insurance_guideline")(e.target.value)}*/}
          {/*    isDisabled={!inEditMode}*/}
          {/*    height="100px"*/}
          {/*  />*/}
          {/*</Flex>*/}
          {/*<Flex flexDirection="column" align="start" width="100%" px={1}>*/}
          {/*  <CustomizeAITextHeaders input="Call Transfer Guideline"*/}
          {/*                          description="Details not listed on the website summary that the AI should know."/>*/}
          {/*  <Textarea*/}
          {/*    value={organized_instructions?.call_transfer_guideline || ""}*/}
          {/*    onChange={(e) => setField("call_transfer_guideline")(e.target.value)}*/}
          {/*    isDisabled={!inEditMode}*/}
          {/*    height="100px"*/}
          {/*  />*/}
          {/*</Flex>*/}
          {/*<Flex flexDirection="column" align="start" width="100%" px={1}>*/}
          {/*  <CustomizeAITextHeaders input="FAQ"*/}
          {/*                          description="Frequently asked question. Questions and answers that are common to your practice."/>*/}
          {/*  <Textarea*/}
          {/*    value={organized_instructions?.faq || ""}*/}
          {/*    onChange={(e) => setField("faq")(e.target.value)}*/}
          {/*    isDisabled={!inEditMode}*/}
          {/*    height="100px"*/}
          {/*  />*/}
          {/*</Flex>*/}
          {/*<Flex flexDirection="column" align="start" width="100%" px={1}>*/}
          {/*  <CustomizeAITextHeaders input="Practice Optimizer Information"*/}
          {/*                          description="Expxanation of how the office manages its data, such as the process for adding treatments."/>*/}
          {/*  <Textarea*/}
          {/*    value={organized_instructions?.practice_optimizer_information || ""}*/}
          {/*    onChange={(e) => setField("practice_optimizer_information")(e.target.value)}*/}
          {/*    isDisabled={!inEditMode}*/}
          {/*    height="100px"*/}
          {/*  />*/}
          {/*</Flex>*/}
          <Flex flexDirection="column" align="start" width="100%" px={1}>
            <Text fontSize="sm" fontWeight="bold" mt={2} ml={1}> Appointment Information Collection </Text>
          </Flex>
          <Flex flexDirection="column" align="start" width="100%" pl={3}>
            <CustomizeAITextHeaders text={<Text fontSize="sm" mt={2}> Appointment blocker fields </Text>}
                                    description="Will not book appointment without this information"/>
            <Textarea
              value={toCSV(organized_instructions?.booking_blocker_fields)}
              onChange={(e) => setField("booking_blocker_fields")(fromCSV(e.target.value))}
              isDisabled={!inEditMode}
            />
            <CustomizeAITextHeaders text={<Text fontSize="sm" mt={2}> Appointment Required fields </Text>}
                                    description="Requested field but AI will book the appointment even if it is not provided.n"/>
            <Textarea
              value={toCSV(organized_instructions?.booking_required_fields)}
              onChange={(e) => setField("booking_required_fields")(fromCSV(e.target.value))}
              isDisabled={!inEditMode}
            />
            <CustomizeAITextHeaders text={<Text fontSize="sm" mt={2}> Appointment Optional fields </Text>}
                                    description="Information that can be collect after the appointment is booked."/>
            <Textarea
              value={toCSV(organized_instructions?.booking_optional_fields)}
              onChange={(e) => setField("booking_optional_fields")(fromCSV(e.target.value))}
              isDisabled={!inEditMode}
            />
            <CustomizeAITextHeaders text={<Text fontSize="sm" mt={2}> Ask if they are a new patient </Text>}
                                    description="Enable if new and existing patients have different data collection requirements."/>
            <Switch
              isChecked={!!organized_instructions?.ask_if_new_patient}
              onChange={(e) => setField("ask_if_new_patient")(e.target.checked)}
              isDisabled={!inEditMode}
            />
            <CustomizeAITextHeaders
              text={<Text fontSize="sm" mt={2}> New patient only: Appointment blocker fields </Text>}
              description="Enable if Appointment blocker fields should only be asked to new patients."/>
            <Switch
              isChecked={!!organized_instructions?.booking_blocker_fields_only_for_new_patients}
              onChange={(e) => setField("booking_blocker_fields_only_for_new_patients")(e.target.checked)}
              isDisabled={!inEditMode}
            />
            <CustomizeAITextHeaders
              text={<Text fontSize="sm" mt={2}> New patient only: Appointment required fields </Text>}
              description="Enable if Appointment required fields should only be asked to new patients."/>
            <Switch
              isChecked={!!organized_instructions?.booking_required_fields_only_for_new_patients}
              onChange={(e) => setField("booking_required_fields_only_for_new_patients")(e.target.checked)}
              isDisabled={!inEditMode}
            />
            <CustomizeAITextHeaders
              text={<Text fontSize="sm" mt={2}> New patient only: Appointment optional fields </Text>}
              description="Enable if Appointment optional fields should only be asked to new patients."/>
            <Switch
              isChecked={!!organized_instructions?.booking_optional_fields_only_for_new_patients}
              onChange={(e) => setField("booking_optional_fields_only_for_new_patients")(e.target.checked)}
              isDisabled={!inEditMode}
            />
            <CustomizeAITextHeaders text={<Text fontSize="sm" mt={2}> After hours call transfer </Text>}
                                    description="Enable to allow AI to transfer calls after hours to specific extensions."/>
            <Switch
              isChecked={!!organized_instructions?.transfer_to_extension_after_hours}
              onChange={(e) => setField("transfer_to_extension_after_hours")(e.target.checked)}
              isDisabled={!inEditMode}
            />
            <CustomizeAITextHeaders text={<Text fontSize="sm" mt={2}> Accept medical insurance </Text>}
                                    description="Enable if you accept medical insurance"/>
            <Switch
              isChecked={!!organized_instructions?.accept_medical}
              onChange={(e) => setField("accept_medical")(e.target.checked)}
              isDisabled={!inEditMode}
            />
          </Flex>
          <Flex flexDirection="column" align="start" width="100%" px={1}>
            <Text fontSize="sm" fontWeight="bold" ml={1}> Filters </Text>
            <Textarea
                value={filtersText}
                onChange={(e) => setFiltersText(e.target.value)}
                onBlur={() => {
                  // only when user leaves the field do we try to parse
                  try {
                    const parsed = JSON.parse(filtersText || "[]");
                    setField("availabilities_filters")(parsed);
                  } catch (err) {
                    console.error("Invalid JSON for availabilities_filters", err);
                  }
                }}
                isDisabled={!inEditMode}
                height="100px"
            />
          </Flex>
        </Flex>
      </Box>
  )
};

export default CustomizeAIDetail;
